module.exports = __webpack_public_path__ + "img/usa.76ce2910.png";